import { useState, useEffect, useRef, useCallback } from "react";
import PT from "prop-types";
import { useTextSearchOptions } from "./hooks";
import debounce from "lodash/debounce";

const DELAY = 250;
const DesktopTextSearch = ({ t, query, ...props }) => {
  const queryRef = useRef(query);
  useEffect(() => {
    queryRef.current = query;
  }, [query]);
  const [search, setSearch] = useState(query.search || "");
  const [searchBy, setSearchBy] = useState(null);
  const options = useTextSearchOptions({ t });
  useEffect(() => {
    if (query.search_by) {
      setSearchBy(options.find(({ value }) => value === query.search_by));
    } else {
      setSearchBy(null);
    }
  }, [query.search_by, options]);
  const changeQuery = useCallback(
    debounce((keyValue) => {
      props.updateQuery(keyValue);
    }, DELAY),
    [props.updateQuery]
  );
  const changeSearch = ({ target: { value } }) => {
    setSearch(value);
    changeQuery({ search: value });
  };
  const changeSearchBy = (data) => {
    changeQuery({ search_by: data?.value || "" });
  };
  const reset = () => {
    setSearchBy(null);
    setSearch("");
    changeQuery({
      search: "",
      search_by: "",
    });
  };
  return props.children({
    search,
    searchBy,
    changeSearch,
    changeSearchBy,
    searchOptions: options,
    reset,
  });
};
DesktopTextSearch.propTypes = {
  query: PT.object.isRequired,

  updateQuery: PT.func.isRequired,
  t: PT.func.isRequired,
};
export default DesktopTextSearch;
